<template>
  <Navigation>
    <AddressesList />
  </Navigation>
</template>
